import config from 'config';
import { reportError } from './ErrorReporting';
import snapshotsActions from '../actions/SnapshotsActions';
import storeManager from '../store/StoreManager';
import utilService from './UtilService';
import sessionReader from '../store/readHelpers/SessionReader';

const snapshotsService = {
    getSnapshotsInterval() {
        const param = parseInt(
            utilService.getUrlParam('snapshotsIntervalInSeconds'),
            10,
        );
        return isNaN(param) ? config.snapshotsInterval : param * 1000;
    },

    storeSnapshot(questionId, interactionId, content) {
        if (sessionReader.shouldDebugSnapshots()) {
            window.console.log('Storing snapshot', content);
        }

        storeManager.dispatch(
            snapshotsActions.addSnapshot(questionId, interactionId, content)
        );
    },

    getSnapshot(questionId, interactionId, timeStamp, { snapshots } = storeManager.getState()) {
        if (snapshots[questionId] && snapshots[questionId][interactionId]) {
            return snapshots[questionId][interactionId][timeStamp];
        }
        return undefined;
    },

    getSnapshots(questionId, interactionId, { snapshots } = storeManager.getState()) {
        if (!snapshots[questionId] || !snapshots[questionId][interactionId]) {
            return [];
        }

        return utilService.arrayFromObject(snapshots[questionId][interactionId]);
    },

    getLatestSnapshot(questionId, interactionId, state = storeManager.getState()) {
        const snapshots = this.getSnapshots(questionId, interactionId, state);
        return snapshots.length === 0 ? undefined : snapshots[snapshots.length - 1];
    },

    startInterval(questionId, interactionId, getContent, snapshotsInterval = this.getSnapshotsInterval()) {
        const interval = setInterval(() => {
            try {
                this.storeSnapshotIfChanged(questionId, interactionId, getContent);
            } catch (error) {
                reportError(error);
                clearInterval(interval);
            }
        }, snapshotsInterval);

        return interval;
    },

    storeSnapshotIfChanged(questionId, interactionId, getContent) {
        const latestSnapshot = this.getLatestSnapshot(questionId, interactionId);
        const currentContent = getContent();

        if (sessionReader.shouldDebugSnapshots()) {
            window.console.log('storeSnapshotIfChanged: latestSnapshot', latestSnapshot, 'currentContent', currentContent);
        }

        /*
         * Store a snapshot if:
         *  - content is not empty
         *  - AND content has changed since the last snapshot OR there is no existing snapshot
         */
        if (currentContent !== ''
            && (!latestSnapshot || latestSnapshot.content !== currentContent)) {
            this.storeSnapshot(questionId, interactionId, currentContent);
        }
    },
};

export default snapshotsService;
